import { connect } from "react-redux";
import ThemMoiKhachHang from "components/CommonComponent/ThemMoiKhachHang";
import { themMoiKhachHang } from "actions/DanhSachKhachHang/ThemMoiKhachHang";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
const mapStateToProps = (state) => ({
    themmoikhachhang: state.themmoikhachhang,
    nguonkhachhang: state.nguonkhachhang,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    themMoiKhachHang: (dataPost) =>
        dispatch(themMoiKhachHang(dataPost)),
    getComboNguonKhachHang: () =>
        dispatch(getComboNguonKhachHang()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemMoiKhachHang);
